interface CategoryItem {
  id: number;
  icon: string;
  name: string;
  count: string;
  color: string;
}

const categories: CategoryItem[] = [
  { id: 1, icon: 'ri-fire-line', name: '热血冒险', count: '1.2万部', color: 'text-red-500 bg-red-50' },
  { id: 2, icon: 'ri-heart-line', name: '恋爱校园', count: '9800部', color: 'text-pink-500 bg-pink-50' },
  { id: 3, icon: 'ri-ghost-line', name: '悬疑推理', count: '5600部', color: 'text-purple-500 bg-purple-50' },
  { id: 4, icon: 'ri-emotion-laugh-line', name: '搞笑日常', count: '1.1万部', color: 'text-orange-500 bg-orange-50' },
  { id: 5, icon: 'ri-sword-line', name: '玄幻修仙', count: '8900部', color: 'text-amber-600 bg-amber-50' },
  { id: 6, icon: 'ri-rocket-line', name: '科幻未来', count: '4300部', color: 'text-cyan-500 bg-cyan-50' },
  { id: 7, icon: 'ri-magic-line', name: '魔法奇幻', count: '7600部', color: 'text-indigo-500 bg-indigo-50' },
  { id: 8, icon: 'ri-run-line', name: '运动竞技', count: '3200部', color: 'text-green-500 bg-green-50' },
  { id: 9, icon: 'ri-history-line', name: '历史古风', count: '5100部', color: 'text-teal-500 bg-teal-50' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">漫画分类</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">海量漫画精准分类，快速找到你想看的香香漫画</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {categories.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl ${item.color} flex items-center justify-center shrink-0 transition-transform duration-200 group-hover:scale-110`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-foreground-900 text-sm md:text-base whitespace-nowrap">{item.name}</div>
                <div className="text-xs text-foreground-500 mt-0.5">{item.count}</div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}